module.exports = __webpack_public_path__ + "img/Reuben_T_Circle.ce86977c.png";